import type { ScratchStore } from '$infra/scratch-store';

const DEVICE_ID_KEY = 'comeback.deviceId';

export async function getDeviceId(scratch: ScratchStore): Promise<string> {
  const existing = await scratch.get<string>(DEVICE_ID_KEY);
  if (existing !== undefined) return existing;

  const deviceId = crypto.randomUUID();
  await scratch.set(DEVICE_ID_KEY, deviceId);
  return deviceId;
}
